import { StepComponentProps } from '../types'

import { ButtonComponent } from './ButtonComponent'
import { FormComponent } from './FormComponent'
import { PopupLinkComponent } from './PopupLinkComponent'
import { LoadingComponent } from './LoadingComponent'

export function DynamicStepComponent(props: StepComponentProps) {
  const { step } = props

  switch (step.type) {
    case 'form':
      return <FormComponent {...props} />
    case 'button':
      return <ButtonComponent {...props} />
    case 'popup_link':
      return <PopupLinkComponent {...props} />
    case 'loading':
      return <LoadingComponent {...props} />
    default:
      return null
  }
}
